/**
 * @description 工具函数
 * @author wangfupeng
 */

/**
 * 变量对象或数组
 * @param {Object} obj 原数据
 * @param {function} fn 回调函数
 */
function each (obj = {}, fn) {
    if (obj instanceof Array) {
        // 数组
        const length = obj.length
        for (let i = 0; i < length; i++) {
            fn(i, obj[i])
        }
    } else {
        // 对象
        for (const key in obj) {
            // eslint-disable-next-line
            if (obj.hasOwnProperty(key)) {
                fn(key, obj[key])
            }
        }
    }
}

/**
 * 深拷贝
 * @param {Object|Array} obj 即将深拷贝的对象或数组
 */
function cloneDeep (obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj
    }
    let result
    if (obj instanceof Array) {
        // 数组
        result = []
        each(obj, (index, value) => {
            result.push(
                cloneDeep(value)
            )
        })
    } else {
        // 对象
        result = {}
        each(obj, (key) => {
            result[key] = cloneDeep(obj[key])
        })
    }
    return result
}

/**
 * 查找所有key对应的id
 *
 * @author tianjingsi
 * @date 2019-10-16
 * @param {Array} data
 * @param {String} key
 * @returns {Array} id列表
 */
function findIdsByKey (data, key) {
    let ids = []
    data.forEach((item) => {
        if (item.key === key) {
            ids.push(item.id)
        }
        if (item.children) {
            ids = ids.concat(findIdsByKey(item.children, key))
        }
    })
    return ids
}

/**
 * 获取 DOM 节点父元素
 * @param {Object} dom DOM 元素节点
 * @param {string} selector 父元素选择器
 */
function getDomParent (dom, selector) {
    if (!selector) return dom.parentNode
    let parent = null
    let iterator = dom.parentNode
    while (iterator && iterator !== document.body && dom !== document.body) {
        if (iterator.matches(selector)) {
            parent = iterator
            break
        }
        iterator = iterator.parentNode
    }

    return parent
}

export {
    each,
    cloneDeep,
    findIdsByKey,
    getDomParent
}
